import { useQuery } from '@tanstack/react-query';

import {
  getFasterforwardEmployees,
  type GetFasterforwardEmployeesResponse,
} from 'wg-api-sdk';

import wgApi from '@/lib/api/wgApi';
import type { QueryOptions } from '@/types/react-query';

import queryKeys from '../queryKeys';

export default function useFasterForwardEmployees(
  options?: QueryOptions<GetFasterforwardEmployeesResponse['items']>,
) {
  return useQuery({
    queryKey: queryKeys.employees.list('fasterforward', undefined),
    queryFn: async () => {
      const result = await getFasterforwardEmployees({}, wgApi);

      return result.items;
    },
    ...options,
  });
}
